export default {
  subtotal: 'Subtotal',
  tip: 'Gorjeta',
  discount: 'Desconto',
  method_fee: 'Taxa de entrega',
  service_fee: {
    title: 'Taxa de serviço',
    description:
      'Esta pequena taxa de serviço ajuda-nos a cobrir os custos associados a cada pedido — como enviar atualizações por SMS sobre o seu pedido, manter a nossa plataforma de encomendas online e cobrir quaisquer taxas de transação adicionais. E não se preocupe — esta taxa ainda é muito inferior ao que pagaria nas apps de entrega. Obrigado pela sua compreensão e por nos apoiar diretamente. Agradecemos!',
  },
  payment_method_upcharge_fee: {
    title: 'Taxa PayPal',
    description:
      'Sempre que um cliente paga com PayPal, o PayPal cobra taxas de 6-7%. Assim, em 100€, perdemos 6-7€. Por isso, infelizmente temos de adicionar um suplemento de 3,5% pelo uso do PayPal. 🤯 Por favor considere utilizar um dos outros métodos de pagamento seguros e encriptados no checkout. Estamos muito gratos pela sua compreensão e apoio! 🙏',
  },
  tax: 'Impostos',
  total: 'Total',
  earned_points: 'Ganhou {{points}} pontos',
};
